import { render, staticRenderFns } from "./ProductEditTabInformation.vue?vue&type=template&id=6ec80847&"
import script from "./ProductEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./ProductEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./ProductEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports